import { useState, useEffect } from "react"
import { useMenu } from "../../../hooks/useMenu"

import { BsFolderMinus, BsFolderPlus, BsHouse, BsHouseFill } from 'react-icons/bs'
import { BsChatSquare, BsChatSquareFill } from 'react-icons/bs'

import TreeMenu, { ItemComponent } from 'react-simple-tree-menu'

import { api } from "../../../services/api"

import styles from './styles.module.scss'

type NavProps = {

}

type CategoriesList = {
    key: string,
    label: string,
    index: number,
    nodeType?: "category",
    parentID?: number,
    nodes?: CategoriesList[]
}

type CategoriesMap = {
    ID: number,
    CM_NOME: string,
    CM_PARENTE_ID: number
}

export function Nav(props: NavProps) {
    const { statusMenu } = useMenu()

    const [windowPath, setWindowPath] = useState({})

    useEffect(() => {
        setWindowPath(window.location.pathname)
    }, [])

    const [treeData, setTreeData] = useState<CategoriesList[]>([{ key: "", label: "", index: -1, nodes: [] }])
    
    function menuCategories(categories: CategoriesList[], menu: null | CategoriesList[]) {

        if (!menu) menu = categories.filter(c => c.parentID === -1)

        menu = menu.map(parentNode => {
            const isChild = (node: CategoriesList) => node.parentID === parseInt(parentNode.key)
            parentNode.nodes = menuCategories(categories, categories.filter(isChild))
            return parentNode
        })
        return menu
    }

    useEffect(() => {

        const fetchDataCatg = async () => {

            const result = await api.get('/categorias')
                .then(resp => resp.data)



            let listaCategorias: CategoriesList[] = result.map((category: CategoriesMap) => ({
                key: category.ID,
                label: category.CM_NOME,
                index: category.ID,
                nodeType: "category",
                parentID: (category.CM_PARENTE_ID === null) ? -1 : category.CM_PARENTE_ID,
                nodes: []
            }))

            let menu = menuCategories(listaCategorias, null)

            setTreeData(menu)

        }

        fetchDataCatg()
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const openedIcon = <BsFolderMinus className={styles.icons} />
    const closedIcon = <BsFolderPlus className={styles.icons} />

    return (
        <div className={styles.navContainer}>
            <div className={!statusMenu ? styles.biggerMenu : styles.lowerMenu}>
                <a href={`/${process.env.REACT_APP_BASE_URL}`}>
                    <div className={windowPath === `/${process.env.REACT_APP_BASE_URL}` || windowPath === `/${process.env.REACT_APP_BASE_URL}/` ? styles.activatedIconsContainer : styles.iconsContainer}>
                        {
                            windowPath === `/${process.env.REACT_APP_BASE_URL}` || windowPath === `/${process.env.REACT_APP_BASE_URL}/` ? <BsHouseFill className={styles.iconsMenu} /> :
                                <BsHouse className={styles.iconsMenu} />
                        }
                        <span>Início</span>
                    </div>
                </a>

                <a href={`/${process.env.REACT_APP_BASE_URL}/ajuda`}>
                    <div className={windowPath === `/${process.env.REACT_APP_BASE_URL}/ajuda` ? styles.activatedIconsContainer : styles.iconsContainer}>
                        {
                            windowPath === `/${process.env.REACT_APP_BASE_URL}/ajuda` ? <BsChatSquareFill className={styles.iconsMenu} /> :
                                <BsChatSquare className={styles.iconsMenu} />
                        }
                        <span>Ajuda</span>
                    </div>
                    {!statusMenu ? <hr /> : ''}
                </a>
            </div>
            <div className={styles.TreeMenu} style={{ display: statusMenu ? "none" : "block" }}>
                <TreeMenu
                    data={treeData}
                    hasSearch={false}
                    initialOpenNodes={["2"]}  
                    activeKey="2"
                    onClickItem={({ ...props }) => {
                        window.location.pathname = `${process.env.REACT_APP_BASE_URL}/categoria/${props.index}`
                    }}>
                    {({ items }) => (
                        <ul>
                            {items.map(({ key, ...props }) => (
                                <ItemComponent key={key} {...props} openedIcon={openedIcon}
                                    closedIcon={closedIcon} />
                            ))}
                        </ul>
                    )}
                </TreeMenu>
            </div>
        </div>
    )
}